import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import QuestionsContainer from '../../common/QuestionsContainer';
import ProfileSuggestionModal from '../../ProfileSuggestionModal';
import './EditRoles.scss';

const getPaginatedQuestionIds = (ids) => ids.map((id) => [id]);

class EditRoles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovering: false,
      showModal: false,
      answers: props.answers,
    };
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleAppendTags = this.handleAppendTags.bind(this);
    this.handleClearSuggestions = this.handleClearSuggestions.bind(this);
  }

  handleMouseOver() {
    this.setState({ isHovering: true });
  }

  handleMouseLeave() {
    const { showModal } = this.state;
    if (!showModal) {
      this.setState({ isHovering: false });
    }
  }

  handleShowModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    const { getAnswers, updateCompletionPercentage } = this.props;
    getAnswers().then((response) => {
      updateCompletionPercentage();
      this.setState({ answers: response.data, showModal: false, isHovering: false });
    });
  }

  handleAppendTags() {
    const { updateSuggestedTags, getAnswers, updateCompletionPercentage } = this.props;

    updateSuggestedTags([], 'HigherLevelRole');

    getAnswers().then((response) => {
      updateCompletionPercentage();
      this.setState({ answers: response.data, showModal: false, isHovering: false });
    });
  }

  handleClearSuggestions(tagIds) {
    const { updateSuggestedTags, suggestedTags } = this.props;

    updateSuggestedTags(suggestedTags.HigherLevelRole.filter((tag) => !(tagIds.includes(tag.id))), 'HigherLevelRole');
  }

  renderEdit() {
    const { editMode, suggestedTags, fullView } = this.props;
    const { isHovering } = this.state;
    if ((!suggestedTags.HigherLevelRole || !suggestedTags.HigherLevelRole.length)
      && (isHovering || editMode) && fullView) {
      return (
        <a
          className="edit-roles medium-weight"
          tabIndex={0}
          role="button"
          onClick={() => this.handleShowModal()}
        >
          Edit
        </a>
      );
    }
    return null;
  }

  renderRoles(roles) {
    const { fullView } = this.props;
    if (roles && roles.length > 0) {
      return (
        <Fragment>
          {roles.map((role) => {
            const proficiency = role.proficiency ? ` (${role.proficiency})` : '';
            return (
              <span className="badge medium blue-light body-text-2 mb-2 me-2" key={role.value}>
                {role.label}
                {proficiency}
              </span>
            );
          })}
          {this.renderEdit()}
        </Fragment>
      );
    }
    if (fullView) {
      return (
        <a
          className="add-answer body-text-2"
          tabIndex={0}
          role="button"
          onClick={() => this.handleShowModal()}
        >
          <i className="fa fa-plus" />
          Add Roles
        </a>
      );
    }
    return null;
  }

  renderRoleSuggestions() {
    const { csrfToken, suggestedTags, showSuggestionModal } = this.props;

    if (!suggestedTags.HigherLevelRole || suggestedTags.HigherLevelRole.length === 0) return null;

    return (
      <ProfileSuggestionModal
        tags={suggestedTags.HigherLevelRole}
        csrfToken={csrfToken}
        appendTags={this.handleAppendTags}
        clearTags={this.handleClearSuggestions}
        forceShow={showSuggestionModal === 'HigherLevelRoles'}
      />
    );
  }

  render() {
    const { showModal, answers } = this.state;
    const {
      questionnaireQuestions,
      questionableId,
      questionableType,
      questionnaireName,
      csrfToken,
    } = this.props;
    const answer = answers.find((a) => a.question_key === 'Roles');
    return (
      <div
        onMouseOver={this.handleMouseOver}
        onMouseLeave={this.handleMouseLeave}
        className="mb-2"
      >
        {this.renderRoles(answer.answer)}
        {this.renderRoleSuggestions()}
        <QuestionsContainer
          key={`${questionnaireName}`}
          questionnaireName={questionnaireName}
          questionIds={[questionnaireQuestions[0]]}
          questionType={answer.question_type}
          questionableId={questionableId}
          questionableType={questionableType}
          csrfToken={csrfToken}
          modalOpen={showModal}
          withModal
          paginated
          paginatedQuestionIds={getPaginatedQuestionIds(questionnaireQuestions)}
          closeModalCallback={this.handleCloseModal}
          owner
        />
      </div>
    );
  }
}

EditRoles.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  editMode: PropTypes.bool.isRequired,
  fullView: PropTypes.bool.isRequired,
  answers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  getAnswers: PropTypes.func.isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  questionnaireName: PropTypes.string.isRequired,
  questionnaireQuestions: PropTypes.arrayOf(PropTypes.number).isRequired,
  updateCompletionPercentage: PropTypes.func.isRequired,
  suggestedTags: PropTypes.shape({}),
  updateSuggestedTags: PropTypes.func,
  showSuggestionModal: PropTypes.string,
};

EditRoles.defaultProps = {
  suggestedTags: {},
  updateSuggestedTags: () => {},
  showSuggestionModal: '',
};

export default EditRoles;
